import React from 'react';

import { GestureResponderEvent } from 'react-native';

import { OfferListItem } from 'components/offer-list-item/offer-list-item';

type IOfferGroupItem = {
  name: string;
  groupId?: string;
  description?: string;
  image: React.ReactNode;
  onPress?: ((event?: GestureResponderEvent) => any) | undefined;
  isPartnershipOffer?: boolean;
  activateButtonLabel?: string;
  onPartnershipActivate?: ((event: GestureResponderEvent) => void) | undefined;
  isWalmartUser?: boolean;
  linkedButtonLabel?: string;
  endDate?: string;
};

export const OfferGroupItem = ({
  name,
  description,
  groupId,
  image,
  onPress,
  isPartnershipOffer,
  activateButtonLabel,
  onPartnershipActivate,
  isWalmartUser,
  linkedButtonLabel,
  endDate,
  ...buttonProps
}: IOfferGroupItem) => (
  <OfferListItem
    isGroup
    header={name}
    description={description}
    image={image}
    onPress={onPress}
    isPartnershipOffer={isPartnershipOffer}
    activateButtonLabel={activateButtonLabel}
    onPartnershipActivate={onPartnershipActivate}
    isWalmartUser={isWalmartUser}
    linkedButtonLabel={linkedButtonLabel}
    endDate={endDate}
    {...buttonProps}
  />
);
